import {Box, Typography} from '@viptech/react-components'

interface Props {
  percentage: number
  height?: string
  fontSize?: string
  color?: string
  showPercentage?: boolean
}

export enum ProgressbarColors {
  GREEN = '#039855',
  ORANGE = '#ffb007',
  RED = '#D92D20',
}

export default function Progressbar({percentage, color, height = '10px', fontSize = '12px', showPercentage = true}: Props) {
  const handleProgressbarColor = () => {
    if (percentage > 70) {
      return ProgressbarColors.GREEN
    } else if (percentage > 40) {
      return ProgressbarColors.ORANGE
    } else {
      return ProgressbarColors.RED
    }
  }

  return (
    <Box display='flex' flex={1} align='center' columnGap='8px'>
      <Box width='100%' height={height} backgroundColor={color ? color + '30' : '#98A2B3'} borderRadius='100px'>
        <Box width={`${percentage}%`} height={height} backgroundColor={color ?? handleProgressbarColor()} position='relative' borderRadius='100px' />
      </Box>
      {showPercentage && (
        <Typography variant='label' size={fontSize} weight={400}>
          {percentage}%
        </Typography>
      )}
    </Box>
  )
}
